module.exports = {
  localization: {
    selectlanguage: "選擇語言",
    type: "中文繁體",
    // 共用
    nav: ["Products", "Accessories", "About Bareiss", "Service & Support"],
    footer: {
      nav: [{
          title: "Bareiss",
          link: ["About Bareiss", "News", "Case studies", "Locations"]
        },
        {
          title: "Products",
          link: ["Products", "Accessories"]
        },
        {
          title: "Service & Support",
          link: ["Calibration", "Download", "Online tutorials", "Knowledge center"]
        },
        {
          title: "Contact us",
          link: ["Inquiries", "After-sales", "Tel"]
        }
      ],
      subscribe: {
        title: "Subscribe to our news",
        txt: "我們會將最新的博銳新聞直接發送到您的收件箱！",
        btn: "Subscribe to our news",
        content: "By subscribing to our news, you agree to our ",
        privacy_policy: "privacy policy"
      },
      copyright: "Copyright © 2021 Bareiss Taiwan Technology Co., Ltd. All rights reserved.",
      map: ["Terms of use", "Privacy policy"]
    },

    //组件
    components: {
      empty_data: "No Data",
      choice: {
        // title: "Why choosing Bareiss？",
        title: "Why would you choose Bareiss？",//zd 20220811 改
        list: [{
            title: "Quality assurance",
            content: "We are known for our production capability and capacity which truly reflect the highest German mechanical craftmanship."
          },
          {
            title: "Intelligent tests",
            content: "Shore/IRHD/VLRH methods intechangeable and exchangeable all at you finger tips. Modular design for flexible configurations"
          },
          {
            title: "70+ years of dedication",
            content: "Founded in 1954, Bareiss has devoted more than 70 years of engineering dedication to material testing technologies."
          },
          {
            title: "DAkkS Calibration",
            content: "Bareiss was honored with the very first accreditation for Shore and IRHD in Germany in 1996. We are truly the pioneer in this field of technology."
          },
          {
            title: "Top-notch services",
            content: "We welcome a trial sample test not only with our headquarters in Germany but also our satellite labs in North America and Asia-Pacific."
          },
          {
            title: "World-class customers",
            content: "Our commitment to quality is endorsed by most of The Fortune Global 500 companies. We are proud to say their products' quality relies on our quality."
          }
        ]
      },
      screen: {
        title: "Select Product",
        test: {
          label: "Type of test",
          placeholder: "Select Tests"
        },
        standard: {
          label: "Standard",
          placeholder: "Select Standard"
        },
        sample: {
          label: "Specimen",
          placeholder: "Select Specimen"
        },
        product: {
          label: "Product",
          placeholder: "Select Product"
        },
        refresh: "Reset"
      },
      subscribeNews: {
        title: "Subscribe to our news",
        txt1: "Subscribe to our newsletters to learn more about Bareiss!",
        txt2: "By subscribing, you agree to our privacy policy",
        name: "Name",
        language: "Language",
        mailbox: "E-mail address",
        submit: "Subscribe",
        verification: {
          name: "Enter Name",
          language: "Select Language",
          mailbox: "Enter mailbox",
          isEmail: "The mailbox is incorrect"
        }
      },
      autoHardness: {
        title: "全自動彈性體硬度測試儀",
        content: "在標準的規範裏, 傳統的硬度計受限在厚度需足6毫米,面積需大於Ø18毫米的樣品上做測試, 因此不適用於任何面積小, 厚度薄,形狀特殊的橡膠或塑料成品上做測試。",
        list: ["模組設計", "即插即用", "非平坦面測試", "超大尺寸", "超薄樣厚", "測法轉換", "USB2.0輸出", "顯示精度", "校正提醒", "完成品測試"]
      },
      hardness: {
        soft: "Soft",
        hard: "Hard"
      },
      serviceAndSupport: {
        title: "About Bareiss",
        nav: ["Calibration", "Download", "Online tutorials", "Knowledge center"]
      },
      contactUs: {
        title: "Knowledge",
        introduce: "拥有最完善的测试设备，任何应用技术上的问题都可透过模拟的方式来了解问题的根本进而寻找出解决的方案。实验室也提供员工以及客户做技术课程训练使用。 博锐逐渐迈向全球化， 目前除了位于德国的总部提供样品代测和技术课程之外， 位于上海的分公司也能提供同样服务给大中华区的客户。 ",
        link: [{
          title: "Enquiries",
          txt: "公司多年來致力於研發創新， 以核心技術為中心",
          btn: "Enquiries"
        }, {
          title: "Enquiries",
          txt: "公司為所有采購設備的客戶提供 上門安裝培訓服務",
          btn: "Enquiries"
        }]
      }
    },

    // 首页
    home: {
      more_details: "Mroe",
      all_products: "All products"
    },
    parts: {
      spare: "零件"
    },
    //rpa页面
    rpa:{
      rubber_analysis_tips: 'For detailed information please click the icons.',
      pdf_download_title: 'Downloads',
      pdf_download_tips: 'For additional information, please use our Download Service',
      about_us_title: 'Quality since 1954',
      about_us: 'About Bareiss',
      contact_us_title: 'We are here for you',
      contact_us:'Contact Bareiss'
    }
  },
};